import {PageHeader} from '../layout/PageHeader'

const InstrumentsWrapper = () => {
  return (
    <>
      <PageHeader
        eyebrow='Рынок'
        title='Инструменты'
        description='Акции, облигации, фонды и валюты в едином каталоге.'
      />
      <instruments-page />
    </>
  )
}

export {InstrumentsWrapper}
